import React, { useState } from 'react'

import { Box, Button, TextField, Typography } from '@material-ui/core'

import { BasePhoneInput, LoadingFeedback } from 'components'
import useSnackbar from 'hooks/useSnackbar'
import helpers from 'helpers'
import * as service from 'service'
import constants from 'constants/index'
import courseConstants from 'constants/courseAccess'
import useStyles from './styles'

const { LOGIN_MODES } = courseConstants

const IdentificationStep = ({
  courseTitle,
  loginMode,
  publicToken,
  portalToken,
  onSuccess,
}) => {
  const classes = useStyles()
  const snackbar = useSnackbar()

  const [isLoading, setIsLoading] = useState(false)
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState(constants.countries.DEFAULT_DDI)

  const isPhoneMode = loginMode === LOGIN_MODES.TWO_FACTOR_PHONE

  const hasValidPhone = phone.replace(/\D/g, '').length >= 10
  const isContactValid = isPhoneMode ? hasValidPhone : !!email.trim()
  const isValid = !!name.trim() && isContactValid

  const handleSubmit = async () => {
    if (!isValid) return
    setIsLoading(true)
    try {
      await service.trainingPortal.inviteCourse.register({
        publicToken,
        portalToken,
        name: name.trim(),
        email: isPhoneMode ? null : email.trim(),
        phone: isPhoneMode ? phone : null,
      })
      onSuccess({
        name: name.trim(),
        email: isPhoneMode ? null : email.trim(),
        phone: isPhoneMode ? phone : null,
      })
    } catch (error) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error?.response?.data?.error) ||
          'Erro ao processar sua solicitação. Tente novamente.',
        variant: 'error',
      })
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Box display="flex" flexDirection="column">
      <LoadingFeedback open={isLoading} />

      {courseTitle && (
        <Box className={classes.courseBanner}>
          <Typography className={classes.courseTitle}>{courseTitle}</Typography>
        </Box>
      )}

      <Typography color="primary" className={classes.title}>
        Cadastro no Curso
      </Typography>
      <Typography className={classes.subtitle}>
        Preencha seus dados para se matricular e acessar o treinamento.
      </Typography>

      <TextField
        label="Nome completo"
        placeholder="Seu nome"
        variant="outlined"
        fullWidth
        className={classes.field}
        value={name}
        onChange={(event) => setName(event.target.value)}
        required
      />

      {isPhoneMode ? (
        <BasePhoneInput
          label="Telefone"
          variant="outlined"
          fullWidth
          className={classes.field}
          value={phone}
          onChange={setPhone}
        />
      ) : (
        <TextField
          label="E-mail"
          placeholder="seu@email.com"
          variant="outlined"
          fullWidth
          type="email"
          className={classes.field}
          value={email}
          onChange={(event) => setEmail(event.target.value)}
          required
        />
      )}

      <Button
        variant="contained"
        color="primary"
        fullWidth
        className={classes.submitButton}
        onClick={handleSubmit}
        disabled={!isValid || isLoading}
      >
        AVANÇAR
      </Button>
    </Box>
  )
}

export default IdentificationStep
